import styled from 'styled-components';

interface LabelProps {
  fontSize?: string;
}

const Label = styled.label<LabelProps>`
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
  font-weight: 700;
  color: #101c16;
  line-height: 18px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default Label;